export default () => {
	const wrapSelect = (select) => {
		const selectParent = select.parentNode;
		if (selectParent.classList.contains('v-form__select')) {
			return;
		}

		const wrapper = document.createElement('span');
		const arrow = document.createElement('span');
		wrapper.classList.add('v-form__select');
		arrow.classList.add('v-form__select-arrow');
		selectParent.insertBefore(wrapper, select);
		wrapper.appendChild(select);
		wrapper.appendChild(arrow);
		select.classList.add('v-form__select-field');
	};

	const selects = document.querySelectorAll('select');
	selects.forEach(wrapSelect);

	document.addEventListener('facetwp-loaded', () => {
		const selects = document.querySelectorAll('select');
		selects.forEach(wrapSelect);
	});

	const tableWrappers = document.querySelectorAll('.v-table-wrapper');
	/**
	 * Toggle scroll indicator classes on table wrappers.
	 * @param {Element} tableWrapper - Table wrapper.
	 * @param {Element} tableInner - Scrollable inner table wrapper.
	 */
	const tableToggleClasses = (tableWrapper, tableInner) => {
		if (tableInner.scrollLeft > 2) {
			tableWrapper.classList.add('v-table-wrapper--scrollable-start');
		} else {
			tableWrapper.classList.remove('v-table-wrapper--scrollable-start');
		}

		if (
			tableInner.scrollLeft + tableInner.clientWidth <
			tableInner.scrollWidth - 2
		) {
			tableWrapper.classList.add('v-table-wrapper--scrollable-end');
		} else {
			tableWrapper.classList.remove('v-table-wrapper--scrollable-end');
		}
	};

	tableWrappers.forEach((tableWrapper) => {
		const inner = tableWrapper.querySelector('.v-table-wrapper__inner');
		inner.addEventListener(
			'scroll',
			tableToggleClasses.bind(null, tableWrapper, inner),
			{ passive: true },
		);

		const observer = new ResizeObserver(() => {
			tableToggleClasses(tableWrapper, inner);
		});
		observer.observe(tableWrapper, { box: 'border-box' });
		tableToggleClasses(tableWrapper, inner);
	});

	const floatingLabels = document.querySelectorAll('.v-form__floating-label');
	if (floatingLabels.length) {
		const floatingInputs = [...floatingLabels].map((l) => {
			const wrap = l.parentElement;
			return wrap.querySelector('input, select, textarea');
		});

		[...floatingInputs].forEach((field, i) => {
			field.addEventListener('focusin', () => {
				floatingLabels[i].classList.add('v-form__floating-label--active');
			});

			field.addEventListener('focusout', () => {
				if (!field.value) {
					floatingLabels[i].classList.remove('v-form__floating-label--active');
				}
			});

			field.addEventListener('change', () => {
				if (!field.value) {
					floatingLabels[i].classList.remove('v-form__floating-label--active');
				}
			});

			const fieldObserver = new MutationObserver((e) => {
				if (!field.value) {
					floatingLabels[i].classList.remove('v-form__floating-label--active');
				}
			});
			fieldObserver.observe(field, { attributes: true });
		});
	}
};
